import { AxiosResponse } from 'axios';
import { useInfiniteQuery, UseInfiniteQueryResult } from 'react-query';
import { UrlParams, PaginatedAppointmentCoachRoleList } from 'types';
import { client } from 'utils/api-client';
import { encodeUrlParams, urlParamsFromUrl } from 'utils/functions';

interface QueryKeyType {
  pageParam?: UrlParams;
  queryKey: (string | undefined)[];
}

interface IUseAppointmentCoachRoles {
  limit?: string;
}

function useAppointmentCoachRoles({
  limit = '20',
}: IUseAppointmentCoachRoles): UseInfiniteQueryResult<AxiosResponse<PaginatedAppointmentCoachRoleList>> {
  const fetchAppointmentCoachRoles = ({
    pageParam = { limit, offset: '0' },
  }: QueryKeyType): Promise<AxiosResponse<PaginatedAppointmentCoachRoleList>> => {
    const params = pageParam;
    return client.get(`appointment-coach-roles/?${encodeUrlParams(params)}`);
  };

  return useInfiniteQuery(['appointmentCoachRoles'], fetchAppointmentCoachRoles, {
    getNextPageParam: page => {
      return page.data.next ? urlParamsFromUrl(page.data.next) : undefined;
    },
  });
}

export default useAppointmentCoachRoles;
